import React from 'react'

export const HiddenNav = ({items}: {items: NavItems}) => {
  return (
    <ul className="visually-hidden">
      {items.map((item, i) => item && <HiddenNavItem key={`nav-${item.key?.toString() || ''}${i.toString()}`} item={item} />)}
    </ul>
  )
}

const HiddenNavItem = ({item}: {item: NavItem | NavSubItem}) => {
  if (!item) return null
  if (!('href' in item)) {
    return null
  }

  return (
    <>
      <li>
        <a href={item.href}>{item.label || ''}</a>
      </li>
      {'children' in item &&
        !!item.children &&
        item.children.map((child: any, i: any) => (
          <HiddenNavItem key={`nav-item-${item.key?.toString() || ''}${i}`} item={child} />
        ))}
    </>
  )
}
